export default defineNuxtRouteMiddleware((to) => {
    if (to.meta?.scrollToTop) {
        setTimeout(() => document.getElementById('page-container')?.scrollTo({top: 0, behavior: 'smooth'}), 50)
    }
})